import WalkthroughPopup from '@/email-maker/grapesjs-email-editor-plugin/src/vos/walkthroughpopup';
import type EmailMakerConstants from '@/email-maker/grapesjs-email-editor-plugin/src/email-maker.types';
import type {MergeTag} from '@Components/merge-tags/merge-tags.types';

export default (): void => {
  introPMWEmailsNamespace();
};

export const MERGE_TAGS: MergeTag[] = [
  {label: 'pmwjs_email', mergeTagKey: 'email', icon: 'icon-envelope', placeholder: 'pmwjs_subscriber'},
  {label: 'pmwjs_first_name', mergeTagKey: 'firstName', icon: 'icon-user', placeholder: 'pmwjs_friends'},
  {label: 'pmwjs_last_name', mergeTagKey: 'lastName', icon: 'icon-user', placeholder: 'pmwjs_member'},
  {label: 'pmwjs_phone_number', mergeTagKey: 'phoneNumber', icon: 'icon-phone', placeholder: 'pmwjs_your_contact'},
  {label: 'pmwjs_birthday', mergeTagKey: 'birthday', icon: 'icon-calendar', placeholder: 'pmwjs_your_special_day'},
  {label: 'pmwjs_address', mergeTagKey: 'address', icon: 'icon-location', placeholder: 'pmwjs_nearby'},
];
export const UNSUPPORTED_EMAIL_STYLES = [
  'background-clip',
  'background-origin',
  'background-attachment',
  'background-blend-mode',
  'transform',
  'transform-origin',
  'transform-style',
  'perspective',
  'perspective-origin',
  'animation',
  'animation-name',
  'animation-duration',
  'animation-timing-function',
  'animation-delay',
  'animation-iteration-count',
  'animation-direction',
  'animation-fill-mode',
  'animation-play-state',
  'transition',
  'transition-property',
  'transition-duration',
  'transition-timing-function',
  'transition-delay',
  'grid',
  'grid-template',
  'grid-template-areas',
  'grid-template-rows',
  'grid-template-columns',
  'grid-area',
  'grid-row',
  'grid-column',
  'grid-gap',
  'grid-row-gap',
  'grid-column-gap',
  'gap',
  'row-gap',
  'column-gap',
  'filter',
  'backdrop-filter',
  'mix-blend-mode',
  'isolation',
  'text-stroke',
  'text-stroke-width',
  'text-stroke-color',
  'hyphens',
  'writing-mode',
  'text-orientation',
  'border-image',
  'border-image-source',
  'border-image-slice',
  'border-image-width',
  'border-image-outset',
  'border-image-repeat',
  'var',
  'clip-path',
  'mask',
  'mask-image',
  'mask-mode',
  'mask-repeat',
  'mask-position',
  'mask-clip',
  'mask-origin',
  'mask-size',
  'mask-composite',
  'object-fit',
  'object-position',
  'resize',
  'user-select',
  'pointer-events',
  'scroll-behavior',
  'scroll-snap-type',
  'scroll-snap-align',
  'will-change',
  'contain',
  'shape-outside',
  'shape-margin',
  'shape-image-threshold',
  'counter-reset',
  'counter-increment',
  'clip',
];

const introPMWEmailsNamespace = (): void => {
  /**
   * email-maker constants
   */
  window.PMW.mergePMW(window.PMW, {
    emails: {
      isInitializingEditor: true,
      RTE_INIT: false,
      AUTOSAVE_STATE_SAVING: 'saving',
      AUTOSAVE_STATE_NOT_SAVED: 'Not Saved',
      AUTOSAVE_STATE_SAVED: 'saved',
      DEVICE_CLASS_PREFIX: '-device-',
      DEVICE_DESKTOP: 'desktop',
      DEVICE_MOBILE: 'mobile',
      DEVICE_TABLET: 'tablet',
      AUTO_WIDTH_CTA_CLASS: 'auto-width-cta',
      EMAIL_DATA_CLIPBOARD_KEY: 'copy_to_window_email',
      EMAIL_COMPONENT_DROPPABLE_KEY: 'email_component_droppable_key',
      HIGHLIGHT_HOVER_CLASS: '-highlight-hover',
      LOCAL_STORAGE_POSTER_ID_KEY: 'email-publish-poster-id',
      ADD_DESIGN_TO_EMAIL_TEMPLATE: 'add-my-design-template',
      READ_ONLY_FOOTER_ID: 'pmw-read-only-footer',
      EMAIL_OVERLAY_ID: 'pmw-email-overlay',
      EMAIL_MEDIA_OVERLAY_ID: 'pmw-email-media-overlay',
      EMAIL_OVERLAY_ANIMATION_TIME_MS: 3000,
      COMPONENT_LOADING_OVERLAY_CLASS: 'pmw-component-loading-overlay-class',
      COMPONENT_LOADING_OVERLAY_WRAPPER_ID: 'pmw-component-loading-overlay-wrapper-id',
      MORE_OPTIONS_DIALOG: 'more-email-options',
      EXPORT_OPTIONS_DIALOG: 'export-options-dialog',
      EXPORT_OPTIONS_DIALOG_MOBILE: 'export-options-dialog-mobile',
      MAX_HTML_CONTENT_LENGTH: 1000000,
      MAX_CONTENT_WIDTH: '920px',
      MAX_VIDEOS_ALLOWED: 5,
      MAX_TRIES_TO_FIND_TOOLBAR: 30,
      MOBILE_CSS_PROP_PREFIX: '--mobile-',
      MODE_START: 'start',
      MODE_LOAD: 'load',
      MODE_COPY: 'copy',
      NEW_TEMPLATE_NAME: 'New email',
      TABLET_CSS_PROP_PREFIX: '--tablet-',
      ZOOM_STEP: 0.2,
      ZOOM_VALUE: 1,
      DEFAULT_ZOOM: 1,
      ZOOM_UPPER_LIMIT: 1.4,
      ZOOM_LOWER_LIMIT: 0.2,
      IS_SCHEDULED: false,
      MINUTES_STEP: 15,
      RTE_TAGNAMES: ['u', 'strikethrough', 'b', 'i', 'strong'],
      PUBLISH_CTA: $('.js-publish-email-btn'),
      SCHEDULED_TIME: null,
      IS_SAVING: false,
      HAS_SAVED: false,
      SAVE_QUEUED: false,
      SAVE_BUTTON_TITLE: window.i18next.t('pmwjs_not_saved_detailed'),
      SHOULD_SHOW_SAVE_CONFLICT: false,
      COPIED_STYLES_COMPONENT: null,
      NONCOPYABLE_STYLES: ['display', 'box-sizing'],
      CUSTOM_EVENT_STORAGE_END: 'custom:storage:end',
      CUSTOM_EVENT_COMPONENT_STYLE_COPIED: 'custom:storage:end',
      NUM_REMOVE_BACKGROUND_CREDITS: 0,
      DESIGN_COPY: 'copy',
      DESIGN_EDIT: 'edit',
      SIGNUP_FORMS_DATA: {offset: 0, limit: 30, signupForms: []},
      COLOR_PALETTES: [],
      COLOR_PALETTE_PILLS: [],
      BUTTON_DEFAULT_PRESET_ID: 4,
      WIDTH_DEFAULT_TOGGLE: 1,
      WALKTHROUGH_CONTAINER_CLASSNAME: '.js-walkthrough-container',
      TOGGLE_OPTION_PRESET_ID_ONE: 1,
      TOGGLE_OPTION_PRESET_ID_ZERO: 0,
      IS_WALKTHROUGH_POPUP_OPEN: false,
      DIVIDER_DEFAULT_HEIGHT: '30px',
      LOCAL_STORAGE_POSTER_PAGE_ID_KEY: 'email-publish-poster-page-id',
      AI_EDIT_ENABLED: false,
      mediaType: {
        IMAGE: 'image',
        VIDEO: 'video',
        ANIMATED_STICKER: 'animated_sticker',
        STILL_STICKER: 'still_sticker',
        ICON: 'icon',
      },
      mediaImageModal: {
        MY_UPLOADS: 'my-uploads-images',
        EXPLORE_MEDIA: 'explore-media-images',
        AI_IMAGES: 'ai-images',
      },
      walkthrough: {
        MAIN_WALKTHROUGH: new WalkthroughPopup('main-walkthrough', false),
        INTRODUCTION_MAIN_WALKTHROUGH: new WalkthroughPopup('introduction-main-walkthrough', false),
        HIERARCHY_LEVEL_ONE: new WalkthroughPopup('hierarchy-level-one', false),
        HIERARCHY_LEVEL_TWO: new WalkthroughPopup('hierarchy-level-two', false),
        ADD_SECTION: new WalkthroughPopup('add-section', false),
        ADD_TABLE: new WalkthroughPopup('add-table', false),
        ADD_BUTTON: new WalkthroughPopup('add-button', false),
        ADD_LINK: new WalkthroughPopup('add-social-links', false),
        ADD_SOCIAL_LINKS: new WalkthroughPopup('add-design', false),
        ADD_DESIGN: new WalkthroughPopup('add-link', false),
      },
      exportOptions: {
        COPY_EMAIL: 1,
        COPY_HTML: 2,
        DOWNLOAD_HTML: 3,
      },
      blocks: {
        CATEGORY_SECTIONS: 'pmw-blocks-sections',
        CATEGORY_ELEMENTS: 'pmw-blocks-elements',
        CATEGORY_TEXT: 'pmw-blocks-text',
        CATEGORY_IMAGE: 'pmw-blocks-image',
        CATEGORY_MY_DESIGNS: 'pmw-blocks-my-designs',
        BLOCK_AI_EDIT: 'pmw-blocks-ai-edit',
        ID_BLOCKS_MANAGER_CONTAINER: 'pmw-blocks-manager-container',
        ID_SECTION_PRESET_1: 'pmwsection1',
        ID_SECTION_PRESET_2: 'pmwsection2',
        ID_SECTION_PRESET_3: 'pmwsection3',
        ID_SECTION_PRESET_4: 'pmwsection4',
        ID_SECTION_PRESET_5: 'pmwsection5',
        ID_SECTION_PRESET_6: 'pmwsection6',
        ID_TEXT_PRESET_1: 'pmwtext1',
        ID_TEXT_PRESET_2: 'pmwtext2',
        ID_UPLOAD_CONTENT: 'pmw-upload-content',
        ID_EXPLORE_MEDIA: 'pmw-explore-media',
        ID_AI_IMAGES: 'pmw-ai-images',
        ID_DESIGN: 'pmwdesign',
        ID_BUTTON: 'pmwbutton',
        ID_SOCIAL: 'pmwsocial',
        ID_DIVIDER: 'pmwdivider',
        ID_TABLE: 'pmwtable',
        ID_STICKER: 'pmwsticker',
        ID_ICONS: 'pmwicons',
        ID_VIDEO: 'pmwvideo',
        ID_ADD_BLOCKS_DIALOG: 'pmw-add-blocks-dialog',
      },
      commands: {
        walkthrough: {
          GET_USER_SEEN_WALKTHROUGH: 'get-user-has-seen-walkthrough',
          GET_USER_LOGGED_IN_SEEN_WALKTHROUGH: 'get-logged-in-user-has-seen-walkthrough',
          GET_NON_LOGGED_IN_USER_SEEN_WALKTHROUGH: 'get-non-logged-in-user-has-seen-walkthrough',
          OPEN_USER_MAIN_WALKTHROUGH_POPUP: 'open-user-main-walkthrough-popup',
          OPEN_USER_INTRODUCTION_MAIN_WALKTHROUGH_POPUP: 'open-user-introduction-main-walkthrough-popup',
          OPEN_ADD_SECTION_WALKTHROUGH_POPUP: 'open-add-section-walkthrough-popup',
          OPEN_ADD_TABLE_WALKTHROUGH_POPUP: 'open-add-table-walkthrough-popup',
          OPEN_ADD_BUTTON_WALKTHROUGH_POPUP: 'open-add-button-walkthrough-popup',
          OPEN_ADD_DESIGN_WALKTHROUGH_POPUP: 'open-add-design-walkthrough-popup',
          OPEN_ADD_LINK_WALKTHROUGH_POPUP: 'open-link-walkthrough-popup',
          OPEN_ADD_STICKER_WALKTHROUGH_POPUP: 'open-sticker-walkthrough-popup',
          OPEN_ADD_VIDEO_WALKTHROUGH_POPUP: 'open-video-walkthrough-popup',
          OPEN_ADD_SOCIAL_LINKS_WALKTHROUGH_POPUP: 'open-add-social-links-walkthrough-popup',
        },
        text: {
          ALIGN_LEFT: 'align-left',
          ALIGN_CENTER: 'align-center',
          ALIGN_RIGHT: 'align-right',
          ALIGN_JUSTIFIED: 'align-justified',
        },
        mediaModals: {
          OPEN_ADD_IMAGE_OPTION_SELECTOR: 'open-add-image-option-selector',
          OPEN_MY_UPLOADS_IMAGE: 'open-my-uploads-image',
          OPEN_EXPLORE_MEDIA_IMAGE: 'open-explore-media-image',
          OPEN_AI_IMAGES: 'open-ai-images',
          OPEN_ADD_VIDEO_OPTION_SELECTOR: 'open-add-video-option-selector',
          OPEN_MY_UPLOADS_VIDEO: 'open-my-uploads-video',
          OPEN_EXPLORE_MEDIA_VIDEO: 'open-explore-media-video',
          OPEN_EMBED_VIDEO: 'open-embed-video',
        },
        ADD_COMPONENT_ANCHOR: 'add-anchor-for-component',
        SANITIZE_COMPONENT_CONTENT: 'sanitize-component-content',
        DELETE_REDUNDANT_COMPONENTS: 'delete-redundant-components',
        ADD_CONTENT_COMPONENT: 'add-content-component',
        AFTER_SAVE: 'after-save',
        TRIGGER_STORAGE_END_EVENT: 'trigger-storage-end-event',
        APPLY_GLOBAL_CELL_STYLES: 'apply-global-cell-styles',
        FIX_COMPONENT_DEFAULT_PROPS: 'fix-component-default-props',
        ATTACH_WINDOW_RESIZE_LISTENER: 'listener-and-resize-editor-window',
        AUTHENTICATE_USER: 'authenticate-user',
        BEFORE_SAVE: 'before-save',
        CLOSE_PREVIEW_DROPDOWN: 'close-preview-dropdown',
        OPEN_MORE_OPTIONS: 'open-more-options',
        CLOSE_MORE_OPTIONS: 'close-more-options',
        INIT_COLLAPSED_STYLES: 'init-collapsed-styles',
        GET_VALIDATED_URL: 'get-validated-url',
        IS_VALID_URL: 'is-validated-url',
        IS_VALID_FOR_LINK: 'is-validated-for-link',
        IS_VIDEO_LINK_WRAPPER: 'is-video-link-wrapper',
        COLLAPSE_STYLE: 'collapse-style',
        UNCOLLAPSE_STYLE: 'uncollapse-style',
        OPEN_CALENDAR_POPUP: 'open-calendar-popup',
        INIT_CALENDAR_DIALOG: 'init-calendar-dialog',
        UPDATE_PUBLISH_CTA_PLACEMENT: 'update-publish-cta-placement',
        GET_PREFILLED_SCHEDULE_DATE: 'get-prefilled-schedule-date',
        DELETE_PREFILLED_SCHEDULE_DATE: 'delete-prefilled-schedule-date',
        CLOSE_SIDE_PANEL: 'close-side-panel',
        INIT_TOOLBAR_AI_REWRITE_DROPDOWN: 'init-toolabr-ai-rewrite-dropdown',
        INIT_MERGE_TAGS: 'init-merge-tags-dropdown',
        OPEN_EXPORT_OPTIONS: 'open-export-options',
        DUPLICATE_COMPONENT: 'duplicate',
        DUPLICATE_EVENT_ACTION: 'EmailMaker_duplicate',
        FINISH_LOADING_EDITOR: 'finish-loading-editor',
        DOES_PMW_DESIGN_BELONG_TO_USER: 'does-pmw-design-belong-to-user',
        CLOSE_OPENED_BLOCK: 'close-opened-block',
        INIT_LOADING_TIPS: 'init-loading-tips',
        EXPORT_TEMPLATE: 'export-templte',
        GENERATE_PREVIEW_IMAGE: 'generate-image-preview',
        GET_COMPONENT_BY_LOAD_IDENTIFIER: 'get-component-by-load-identifier',
        DOES_COMPONENT_HAVE_LINK: 'does-component-have-link',
        GET_DESIGN_IDS: 'get-design-ids',
        GET_EMAIL_HTML_PROMISE: 'get-email-html-promise',
        GET_IMAGE_ASSET_HASHED_NAMES: 'get-image-asset-hashed-names',
        FIX_WRAPPER_WIDTH: 'fix-wrapper-width',
        OPEN_CUSTOM_HTML_DIALOG: 'open-custom-html-dialog',
        GET_VIDEO_ASSET_HASHED_NAMES: 'get-video-asset-hashed-names',
        COPY_MEDIA_QUERIES_FOR_MARKETING_EMAIL: 'copy-media-queries-for-marketing-email',
        SHOW_BANNER: 'show-banner',
        HIDE_BANNER: 'hide-banner',
        FIX_UPPER_CASE_LIMIT: 'fix-upper-case-limit',
        DISABLE_BLOCKS: 'disable-blocks',
        ENABLE_BLOCKS: 'enable-blocks',
        GET_INLINED_HTML: 'gjs-get-inlined-html',
        GET_INLINED_HTML_FOR_MARKETING: 'get-inlined-html-for-marketing',
        GET_MEDIA_QUERIES: 'get-media-queries',
        GET_PREMIUM_DESIGN_IDS: 'get-premium-design-ids',
        GET_COMPONENT_STYLE: 'get-style',
        GET_TEMPLATE_NAME: 'get-template-name',
        GET_VIDEO_COUNT: 'get-video-count',
        H_ALIGN_COMPONENT_CENTER: 'horizontal-align-center',
        H_ALIGN_COMPONENT_LEFT: 'horizontal-align-left',
        H_ALIGN_COMPONENT_RIGHT: 'horizontal-align-right',
        UPDATE_COMPONENT_ALIGNMENT_COMPATIBILITY: 'update-component-alignment-compatibility',
        UPDATE_STYLE_BUTTON_STATE: 'update-style-button-state',
        HIGHLIGHT_CELL_SPACING: 'highlight-cell-spacing',
        HIGHLIGHT_COMPONENT_PADDING: 'highlight-padding',
        HANDLE_TABLE_PADDING: 'handle-table-padding',
        REMOVE_BUGGY_BACKGROUND_ATTRIBUTE: 'remove-buggy-background-attribute',
        HANDLE_TABLE_MARGIN: 'handle-table-margin',
        INITIATE_BLOCK_MANAGER: 'initiate-block-manager',
        UPDATE_SHARE_BUTTON_ICON: 'update-share-button-icon',
        IS_USER_OWNER: 'is-user-owner',
        MOVE_COMPONENT_ANCHOR: 'move-anchor-for-component',
        ON_ADD_BRAND_ASSET: 'on-add-brand-asset',
        ON_ALL_COMPONENTS_LOADED: 'on-all-comps-loaded',
        OPEN_ADD_BLOCKS_DIALOG: 'open-add-blocks-dialog',
        OPEN_CROPPER: 'open-cropper',
        REMOVE_BACKGROUND: 'remove-background',
        INIT_AUTOSAVE_UI: 'init-autosave-nav-ui',
        GET_REMOVE_BG_CREDITS: 'get-remove-background-credits',
        DISABLE_EDITOR_CONTROLS: 'disable-editor-controls',
        ENABLE_EDITOR_CONTROLS: 'enable-editor-controls',
        INIT_AUTOSAVE: 'init-autosave',
        OPEN_DESIGN_SELECTOR: 'open-design-selector',
        OPEN_IMPORT_TEMPLATE: 'gjs-open-import-template',
        OPEN_MEDIA_MODAL: 'open-media-modal',
        OPEN_POSTERMAKER: 'open-postermaker',
        OPEN_PREVIEW_DIALOG: 'open-preview-dialog',
        OPEN_SIDE_PANEL: 'open-side-panel',
        OPEN_STICKER_MODAL: 'open-sticker-modal',
        OPEN_ICONS_MODAL: 'open-icons-modal',
        EMAIL_EXPORTED: 'email-exported',
        REATTACH_COMPONENT_ANCHOR: 'reattach-anchor-for-component',
        ADD_READONLY_FOOTER: 'add-readonly-footer',
        REMOVE_UNSUPPORTED_STYLES: 'remove-unsupported-styles',
        GET_STORAGE_DATA_WITHOUT_FOOTER: 'get-storage-data-without-footer',
        REMOVE_READONLY_FOOTER: 'remove-readonly-footer',
        RELOAD_ALL_DESIGNS: 'reload-all-designs',
        RELOAD_MODIFIED_DESIGN: 'reload-modified-design',
        RELOAD_PREMIUM_BACKGROUNDS: 'reload-premium-backgrounds',
        REMOVE_COMPONENT: 'remove-component',
        REMOVE_COMPONENT_ANCHOR: 'remove-anchor-for-component',
        SAVE_AND_PUBLISH: 'save-and-publish',
        CORE_COMPONENT_COPY: 'component:copy',
        CORE_COMPONENT_PASTE: 'component:paste',
        CUT_COMPONENT: 'cut-compoent',
        VALIDATE_TBODY_COMPONENT_TYPES: 'validate-tbody-component-types',
        VALIDATE_ALL_TBODY_COMPONENTS: 'validate-all-tbody-components',
        VALIDATE_TEMPLATE_AND_PUBLISH: 'validate-template-and-publish',
        SAVE_AND_CLOSE_EMBEDDED_EDITOR: 'save-and-close-embedded-editor',
        CLOSE_EMBEDDED_EDITOR: 'close-embedded-editor',
        SAVE_TO_CACHE: 'save-to-db',
        SAVE_TO_DB: 'save-to-db-from-cache',
        SAVE_TO_DB_AND_CACHE: 'complete-save-to-db',
        SCROLL_TO_COMPONENT: 'scroll-to-component',
        SET_AUTOSAVE: 'set-autosave',
        RESET_SAVE_DIRTY_COUNT: 'reset-save-dirty-count',
        SET_COMPONENT_STYLE: 'set-style',
        SET_TEXT_COLOR_STYLE: 'set-text-color-style',
        SET_DEFAULT_SELECTION: 'set-default-selection',
        SET_DEVICE_DESKTOP: 'set-device-desktop',
        SET_DEVICE_MEDIA_QUERY: 'set-device-media-query',
        UPDATE_DIVIDER_COMPATIBILITY_PROPERTY: 'update-divider-compatibility-property',
        UPDATE_IMAGE_ALIGNMENT_COMPATIBILITY: 'update-image-alignment-compatibility',
        GET_COMPONENT_HORIZONTAL_ALIGNMENT: 'get-component-horizontal-alignment',
        ADD_ALIGN_ATTRIBUTE: 'add-align-attribute',
        SET_DEVICE_MOBILE: 'set-device-mobile',
        SET_DEVICE_TABLET: 'set-device-tablet',
        SET_IMAGE_CROPDATA: 'set-img-cropdata',
        SET_IMAGE_LOADING: 'set-img-loading',
        GET_COMPONENT_MEDIA_TYPE: 'get-component-media-type',
        COPY_STYLES: 'copy-styles',
        PASTE_STYLES: 'paste-styles',
        SET_IMAGE_SRC: 'set-img-src',
        SET_EMBEDDED_VIDEO_SRC: 'set-embedded-video-src',
        GET_ALL_IMAGES_INFO: 'get-all-imgs-info',
        OPEN_COMPONENT_INFO_MODAL: 'open-modal-info-modal',
        COPY_HTML_FOR_MARKETING_EMAIL: 'copy-html-for-marketing-email',
        COPY_TEXT_FOR_MARKETING_EMAIL: 'copy-text-for-marketing-email',
        SHOW_GETTY_LIMIT_MESSAGE: 'show-getty-limit-message',
        TOGGLE_BUY_GETTY_DESIGN_MESSAGE: 'show-buy-getty-design-message',
        UPDATE_MS_OUTLOOK_STYLES: 'update-ms-outlook-styles',
        SET_LEGACY_MAIL_COMPATIBILITY: 'set-legacy-mail-compatibility',
        UPDATE_BG_IMAGE_GMAIL_COMPATIBILITY: 'update-bg-image-gmail-compatibility',
        UPDATE_BUTTON_AOL_COMPATIBILITY: 'update-button-aol-compatibility',
        UPDATE_TABLE_OUTLOOK_COMPATIBILITY: 'update-table-outlook-compatibility',
        UPDATE_PUBLISH_CTA_UI: 'update-publish-cta-ui',
        REPLACE_BG_IMAGE_ATTRIBUTE_WITH_STYLE: 'replace-bg-image-attribute-with-style',
        HAS_WIDTH_PROPERTY: 'has-width-property',
        START_UPDATING_SAVE_TIME: 'start-updating-save-time',
        SYNC_UPDATED_DB_CONTENT: 'sync-updated-db-content',
        SYNC_GETTY_COUNT_FOR_COMPONENTS: 'sync-getty-count-for-components',
        UPDATE_GETTY_COUNTS_FOR_EMAIL: 'update-getty-counts-for-email',
        DOES_EMAIL_CONTAIN_GIF: 'does-email-contain-gif',
        TOGGLE_COMPONENT_LOCK: 'toggle-lock',
        TOGGLE_COMPONENT_STYLE: 'toggle-style',
        TOGGLE_STYLE_BOLD: 'toggle-bold',
        TOGGLE_STYLE_ITALIC: 'toggle-italic',
        TOGGLE_STYLE_STRIKETHROUGH: 'toggle-strikethrough',
        IS_OF_TYPE_TABLE: 'is-of-type-table',
        IS_OF_TYPE_CELL: 'is-of-type-cell',
        UPDATE_CONTENT_MAX_WIDTH: 'update-content-max-width',
        IS_OF_TYPE_GRAPHIC: 'is-of-type-graphic',
        IS_OF_TYPE_CONTAINER: 'is-of-type-container',
        UPDATE_LEGACY_DIVIDERS: 'update-legacy-dividers',
        TOGGLE_STYLE_UNDERLINE: 'toggle-underline',
        TOTAL_COMPONENT_COUNT: 'total-count-of-components',
        TRACK_GA_EVENT_COMPONENT: 'track-ga-event-component',
        UNABLE_TO_SAVE: 'unable-to-save',
        UPDATE_TEXT_COMPONENT_LINK_COLOR: 'update-text-component-link-color',
        UPDATE_LINKS_COLOR: 'update-links-color',
        UPDATE_CELL_BACKGROUND_COLOR: 'update-cell-background-color',
        UPDATE_CELL_BORDER_COLOR: 'update-cell-border-color',
        UPDATE_CELL_BORDER_RADIUS: 'update-cell-border-radius',
        UPDATE_CELL_BORDER_WIDTH: 'update-cell-border-width',
        UPDATE_CELLS_BACKGROUND_COLOR: 'update-cells-background-color',
        UPDATE_CELLS_BORDER_COLOR: 'update-cells-border-color',
        UPDATE_CELLS_BORDER_RADIUS: 'update-cells-border-radius',
        UPDATE_CELLS_BORDER_WIDTH: 'update-cells-border-width',
        UPDATE_CELLS_SPACING: 'update-cell-spacing',
        UPDATE_COLUMNS_PRESET: 'update-columns-preset',
        GET_SECTION_COLUMNS_PRESETS: 'get-section-columns-presets',
        UPDATE_GETTY_COUNT: 'update-getty-count',
        UPDATE_LOADING_IMG_WITH_RESPONSE: 'update-loading-img-src-with-response',
        UPDATE_SAVE_BUTTON: 'update-save-btn',
        UPDATE_SECTION_RESPONSIVE: 'update-section-responsive',
        UPDATE_MERGE_TAGS: 'update-merge-tags',
        SYNC_TABLE_TBODY_COLORS: 'sync-table-tbody-colors',
        UPDATE_SLIDER_VALUE: 'update-slider-value',
        MAKE_STYLEMANAGER_ACTIVE: 'make-stylemanager-active',
        MAKE_STYLEMANAGER_INACTIVE: 'make-stylemanager-inactive',
        TOGGLE_STYLEMANAGER_SCROLL_LISTENER: 'toggle-stylemanager-scroll-listener',
        TOGGLE_STYLEMANAGER_HEIGHT: 'toggle-stylemanager-height',
        UPDATE_SOCIAL_LINK_SPACING: 'update-social-link-spacing',
        UPDATE_SOCIAL_LINK_SIZE: 'update-social-link-size',
        UPDATE_SOCIAL_LINK_ICON_STYLE: 'update-social-link-icon-style',
        UPDATE_TABLE_COLUMNS: 'update-table-columns',
        UPDATE_TABLE_ROWS: 'update-table-rows',
        GET_PRIMARY_TABLE_COMPONENT: 'get-primary-table-component',
        UPDATE_UNDO_REDO_STATES: 'update-undo-redo-states',
        USER_LOGGED_IN: 'user-logged-in',
        V_ALIGN_COMPONENT_BOTTOM: 'vertical-align-bottom',
        V_ALIGN_COMPONENT_MIDDLE: 'vertical-align-middle',
        V_ALIGN_COMPONENT_TOP: 'vertical-align-top',
        ZOOM_IN: 'zoom-in-canvas',
        ZOOM_OUT: 'zoom-out-canvas',
        FIT_TO_SCREEN: 'fit-to-screen',
        EXPAND_WIDTH_SLIDER: 'expand-width-slider',
        INIT_WIDTH_SLIDER_STYLE: 'init-width-slider-style',
        INIT_BORDER_SUBOPTIONS: 'init-border-sub-options',
        INIT_STYLE_FOR_LINK_COLOR: 'init-style-for-link-color',
        SHRINK_WIDTH_SLIDER: 'shrink-width-slider',
        SET_CUSTOM_WIDTH_STYLE: 'set-custom-width-style',
        SET_AUTO_WIDTH_STYLE: 'set-auto-width-style',
        REFRESH_MEDIA_QUERIES: 'refresh-media-queries',
        COPY_MEDIA_QUERIES_TO_RESPONSIVE_STYLE: 'copy-media-queries-to-responsive-style',
        REMOVE_MEDIA_QUERIES: 'remove-media-queries',
        GET_UPDATED_LINK_ATTRIBUTES: 'get-updated-link-attributes',
        GET_COMPONENT_FOR_TOGGLE_SWITCH: 'get-component-for-toggle-switch',
        GET_ALL_COMPONENTS_WITH_FONT: 'get-all-components-with-font',
        GET_TABLE_COMPONENT_FOR_BUTTON: 'get-table-component-for-button',
        SELECT_NEXT_ITEM: 'select-next-item',
        SELECT_PREVIOUS_ITEM: 'select-previous-item',
        UNSELECT_COMPONENT: 'unselect-component',
        GET_MAIN_WRAPPER: 'get-main-wrapper',
        GET_READ_ONLY_FOOTER: 'get-read-only-footer',
        REFRESH_STYLEMANAGER: 'refresh-stylemanager',
        REFRESH_EDITOR: 'refresh-editor',
        SHOW_KEYBOARD_SHORTCUTS: 'show-keyboard-shortcuts',
        ADD_STYLE_HEADER: 'add-style-header',
        UPDATE_SECTOR_TITLE: 'update-sector-title',
        ASYNC_GET_SIGNUP_FORMS: 'async-get-signup-forms',
        FIX_COMPONENT_FULL_WIDTH_OVERFLOW_AOL_YAHOO: 'fix-component-full-width-overflow-aol-yahoo',
        SANITIZE_ALL_COMPONENTS: 'sanitize-all-components',
        SET_TARGET_BLANK_FOR_ALL_LINKS: 'set-target-blank-for-all-links',
        IS_COMPONENT_WIDTH_UNSET: 'is-component-width-unset',
        IS_COMPONENT_INSIDE_COMPONENT: 'is-component-inside-component',
        ADD_COPY_TABLE_STYLE_TO_TABLE_BODY_LISTENER: 'add-copy-table-style-to-table-body-listener',
        DOES_TABLE_HAVE_ROUNDNESS: 'does-table-have-roundness',
        GET_PENDING_MARKETING_POPUP: 'get-pending-marketing-popup',
        LISTENER_PASTE_AS_TEXT: 'listener-paste-as-text',
        APPLY_AUTO_BRANDING_STYLE: 'apply-auto-branding-style',
        TOGGLE_LOADING_OVERLAY_FOR_EMAIL: 'toggle-loading-overlay-for-email',
        GET_LOADING_OVERLAY_FOR_EMAIL: 'get-loading-overlay-for-email',
        FIX_LOADING_OVERLAY_FOR_EMAIL_SIZE: 'fix-loading-overlay-for-email-size',
        TOGGLE_MEDIA_COMPONENT_OVERLAY: 'toggle-media-component-overlay',
        TOGGLE_COMPONENT_LOADING_OVERLAY: 'toggle-component-loading-overlay',
        REMOVE_COMPONENT_LOADING_OVERLAYS_ON_LOAD: 'remove-component-loading-overlays-on-load',
        GET_EDITABLE_COMPONENTS: 'get-editable-components',
        REPLACE_HTML_CONTENT: 'replace-html-content',
        GET_EDITABLE_HTML: 'get-editable-html',
        ASYNC_FETCH_ALL_COLOR_PALETTES: 'async-fetch-all-color-palettes',
        ASYNC_FETCH_ALL_COLOR_PALETTE_PILLS: 'async-fetch-all-color-palette-pills',
        GET_ALL_COLORS_HEXES_IN_COMPONENT: 'get-all-colors-in-component',
        FETCH_SOCIAL_LINK_SUGGESTION: 'fetch-social-link-suggestions',
        AI_REWRITE_EMAIL_CAMPAIGN_TEXT_COMPONENTS_CONTENT: 'rewrite-content',
        AI_REDESIGN_EMAIL_CAMPAIGN: 'redesign-email-campaign',
        AI_REGENERATE_EMAIL_CAMPAIGN_IMAGES: 'regenerate-images',
        AI_REGENERATE_EMAIL_TEMPLATE_DESIGNS: 'regenerate-designs',
        COPY_TEXT_JSON: 'copy-text-json',
        IS_MULTISELECT: 'is-multiselect',
        REMOVE_PARAMS_FROM_URL: 'remove-params-from-url',
        GET_AUTO_UPDATES: 'get-auto-updates',
        APPLY_AUTO_UPDATES: 'apply-auto-updates',
        GET_INLINE_STYLED_COMPONENT: 'get-inline-styled-component',
        SAVE_COMPONENT_TEMPLATE: 'save-component-template',
        SAVE_USER_COMPONENT_TEMPLATE: 'save-user-component-template',
        CLOSE_ADD_BLOCKS_DIALOG: 'close-add-blocks-dialog',
        GET_ALL_COMPONENTS_BY_TYPE: 'get-all-components-by-type',
        GET_PUPPETEER_CONFIG: 'get-puppeteer-config',
        ADD_PUPPETEER_LISTENERS: 'add-puppeteer-listeners',
        FIX_VERTICAL_ALIGNMENT_VISUAL: 'fix-vertical-alignment-visual',
        TOGGLE_AI_EDIT: 'toggle-ai-edit',
        FETCH_AI_REWRITE_RECENT_PROMPT: 'fetch-ai-rewrite-recent-prompt',
        INSERT_COMPONENT: 'insert-component',
        POPULATE_MY_DESIGN_PAGE_ID: 'populate-my-design-page-id',
      },
      components: {
        default: {
          WRAPPER: 'wrapper',
          IMAGE: 'image',
          TBODY: 'tbody',
          LINK: 'link',
          ROW: 'row',
          CELL: 'cell',
          TABLE: 'table',
          TEXT: 'text',
          DEFAULT: 'default',
        },
        table: {
          PMW_TABLE: 'postermywall-table',
          PMW_TBODY: 'postermywall-tbody',
          PMW_ROW: 'postermywall-row',
          PMW_CELL: 'postermywall-cell',
          PMW_STATIC_CELL: 'postermywall-static-cell',
          PMW_SECTION: 'postermywall-section',
        },
        social: {
          PMW_SOCIALS: 'postermywall-socials',
          PMW_SOCIALS_ITEM: 'postermywall-social-item',
          PMW_SOCIALS_IMAGE: 'postermywall-social-image',
        },
        graphic: {
          PMW_DESIGN: 'postermywall-design',
          PMW_IMAGE: 'postermywall-image',
          PMW_VIDEO: 'postermywall-video',
          PMW_STICKER: 'postermywall-sticker',
          PMW_ICON: 'postermywall-icon',
        },
        container: {
          PMW_WRAPPER: 'postermywall-wrapper',
          PMW_CONTENT_CONTAINER: 'postermywall-content-container',
          PMW_CONTENT: 'postermywall-content',
          PMW_WRAPPER_CELL: 'postermywall-wrapper-cell',
        },
        text: {
          PMW_LINK: 'postermywall-link',
          PMW_BUTTON: 'postermywall-button',
          PMW_TEXT: 'postermywall-text',
        },
        misc: {
          PMW_DIVIDER_CELL: 'postermywall-divider-cell',
          PMW_DIVIDER: 'postermywall-section-divider',
          PMW_DIVIDER_LEGACY: 'postermywall-divider',
          PMW_DIV: 'postermywall-div',
          PMW_READ_ONLY_FOOTER: 'postermywall-readonly-text',
        },
      },
      buttonPresets: {
        1: 0,
        2: 6,
        3: 12,
        4: 50,
      },
      props: {
        COLUMNS_PRESET: 'pmw-columns-preset',
        APPLY_INITIAL_PRESET: 'pmw-apply-initial-preset',
        MEDIA_MODAL: 'pmw-media-modal',
        COMPONENT_PRESET: 'pmw-component-preset',
        WIDTH_CUSTOM: 'pmw-component-width-custom',
        CONTENT_SOURCE: 'pmw-content-source',
        CROP_DATA: 'pmw-crop-data',
        DESIGN_ID: 'data-design-id',
        DESIGN_PAGE_ID: 'data-design-page-id',
        DESIGN_CREATOR_ID: 'pmw-design-creator-id',
        DESIGN_MODIFIED: 'pmw-design-modified',
        HAS_BACKGROUND_MEDIA: 'pmw-has-background',
        HASHED_FILENAME: 'hashedFilename',
        REMOVED_BACKGROUND_URL: 'removed-background-url',
        HIERARCHY_SELECTION: 'pmw-hierarchy-selection',
        HIERARCHY_ROOT: 'pmw-hierarchy-root',
        HAS_BORDER_CONTROLS: 'has-border-controls',
        BORDER_CONTROLS_ATTACHED: 'border-controls-attached',
        IS_MEDIA: 'pmw-is-media',
        IS_CROPPABLE: 'pmw-croppable',
        IS_PREMIUM_DESIGN: 'pmw-premium-design',
        IS_INTERNAL: 'pmw-is-internal',
        MEDIA_TYPE: 'pmw-media-type',
        PARENT_ANCHOR_COMPONENT_ID: 'pmw-parent-anchor-component-id',
        PREMIUM_IMAGE_COUNT: 'gettyImageCount',
        PREMIUM_VIDEO_COUNT: 'gettyVideoCount',
        TEMPLATE_NAME: 'pmw-email-template-name',
        UNCROPPED_SRC: 'pmw-uncropped-src',
        DROP_IDENTIFIER: 'data-drop-identifier',
        IS_RESPONSIVE_MOBILE: 'responsive',
        IS_RESPONSIVE_TABLET: 'responsive-tablet',
      },
      styles: {
        ID_COLOR_PICKER: 'pmw-colorpicker',
        ID_INFO_BOX: 'pmw-info-box',
        ID_LIST: 'pmw-list',
        ID_CTA_BUTTON: 'pmw-cta-button',
        ID_MOD_LIST: 'pmw-mod-list',
        ID_PRESET_SELECTOR: 'pmw-preset-component-selector',
        ID_TOGGLE_BUTTON: 'pmw-toggle-button',
        ID_TOGGLE_SWITCH: 'pmw-toggle-switch',
        ID_SLIDER: 'pmw-slider',
        ID_SOCIAL_LINKS: 'pmw-social-links',
        ID_STEP_BUTTONS: 'pmw-step-buttons',
        ID_STYLE_HEADER: 'pmw-style-header',
        ID_UPLOAD_BUTTON: 'pmw-upload-button',
        ID_SHORTCUT_LIST: 'pmw-shortcut-list',
        ID_LINK_WRAPPER: 'pmw-link-wrapper',
        LINK_COLOR: 'pmw-link-color',
        ID_AUTO_BRANDING: 'pmw-auto-branding',
        ID_AI_REWRITE_PROMPT_BOX: 'pmw-ai-rewrite-prompt-box',
        ID_DROPDOWN_STYLE_SELECTOR: 'pmw-dropdown-selector',
        ID_MERGE_TAGS: 'pmw-merge-tags',
        ID_SINGLE_COMPONENT_AI_REWRITE_PROMPT_BOX: 'pmw-single-component-ai-rewrite-prompt-box',
      },
    },
  } as unknown as EmailMakerConstants);
};
